import { loadModules } from "esri-loader";

export default class SaveService {
  constructor() {}

  static saveMap(mapAsFeature, featureToOverwrite) {
    return new Promise((resolve, reject) => {
      loadModules(["esri/layers/FeatureLayer"]).then(([FeatureLayer]) => {
        let saveService = new FeatureLayer(
          process.env.VUE_APP_MAP_SAVE_SERVICE_URL
        );

        let applyEditsParameters;

        if (featureToOverwrite == null) {
          applyEditsParameters = { addFeatures: [mapAsFeature] };
        } else {
          mapAsFeature.attributes.OBJECTID =
            featureToOverwrite.attributes.OBJECTID;
          applyEditsParameters = { updateFeatures: [mapAsFeature] };
        }

        saveService
          .applyEdits(applyEditsParameters)
          .then(result => {
            resolve(result);
          })
          .catch(error => {
            reject(error);
          });
      });
    });
  }
}
